import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _ from "lodash";
import BigNumber from "bignumber.js";
import InputNumber from "primevue/inputnumber";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UDecimalInput',
    props: {
        modelValue: {
            type: String,
            default: ""
        },
        decimal: {
            type: Number,
            default: 0
        },
        indent: {
            type: Number,
            default: 2
        },
        placeholder: {
            type: String,
            default: ""
        },
        readonly: {
            type: Boolean,
            default: false
        },
        faded: {
            type: Boolean,
            default: false
        },
        max: {
            type: String,
            default: null
        },
        min: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: ""
        }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const maxResult = computed(() => {
            if (!props.max) {
                return undefined;
            }
            if (!props.decimal) {
                return Number(props.max);
            }
            const num = new BigNumber(Number(props.max));
            const divisor = new BigNumber(10).pow(props.decimal);
            return num.dividedBy(divisor).toNumber();
        });
        const minResult = computed(() => {
            if (!props.min) {
                return undefined;
            }
            if (!props.decimal) {
                return Number(props.min);
            }
            const num = new BigNumber(Number(props.min));
            const divisor = new BigNumber(10).pow(props.decimal);
            return num.dividedBy(divisor).toNumber();
        });
        const displayValue = computed(() => {
            if (props.modelValue === "" || props.modelValue === null || _.isNaN(props.modelValue)) {
                return undefined;
            }
            let value = props.modelValue;
            if (typeof value === "string") {
                value = value.replace(",", ".");
            }
            try {
                if (props.decimal) {
                    const bnValue = new BigNumber(value);
                    const divisor = new BigNumber(10).pow(props.decimal);
                    const result = bnValue.dividedBy(divisor);
                    return result.isNaN() ? 0 : result.toNumber();
                }
                const numericValue = Number(value);
                return isNaN(numericValue) ? 0 : numericValue;
            }
            catch (error) {
                console.error("Error converting value to number:", error);
                return 0;
            }
        });
        const onInput = (value) => {
            if (value !== 0) {
                let bnValue = new BigNumber(value);
                if (maxResult.value && bnValue.isGreaterThan(maxResult.value)) {
                    bnValue = new BigNumber(maxResult.value);
                }
                if (props.decimal) {
                    const multiplier = new BigNumber(10).exponentiatedBy(props.decimal);
                    bnValue = bnValue.multipliedBy(multiplier);
                }
                emit("update:modelValue", bnValue.toString());
            }
            else if (value.toString() !== props.modelValue) {
                emit("update:modelValue", value.toString());
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(InputNumber), {
                "model-value": displayValue.value,
                "use-grouping": false,
                class: _normalizeClass(["input", { 'faded': __props.faded }]),
                name: __props.name,
                placeholder: __props.placeholder,
                readonly: __props.readonly,
                min: minResult.value,
                max: maxResult.value,
                "max-fraction-digits": __props.indent,
                locale: "en-US",
                "onUpdate:modelValue": onInput
            }, null, 8, ["model-value", "name", "class", "placeholder", "readonly", "min", "max", "max-fraction-digits"]));
        };
    }
});
